import { useAuth } from "react-oidc-context";
import { Button, Card, Container } from "react-bootstrap";
import BrandLogo from "../components/BrandLogo";

export default function SignIn() {
  const auth = useAuth();
  return (
    <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
      <Card style={{ maxWidth: 420 }} className="shadow-sm">
        <Card.Body className="text-center p-4">
          <div className="mb-3">
            <BrandLogo height={30} />
          </div>
          <Card.Title as="h4" className="mb-1">
            SE Candidate Panel Scorecard
          </Card.Title>
          <Card.Text className="text-muted mb-4">
            Sign in with your LaunchDarkly Google account to score candidates.
          </Card.Text>
          <Button size="lg" onClick={() => void auth.signinRedirect()}>
            Sign in with Google
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}
